import { Easing } from '@tweenjs/tween.js';
import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import ElementComponent from '../../../Component/UI/Element';
import Renderable from '../../../Component/Renderable';
import { Random } from '../../../Utility/Random';
import { MathHelper } from '../../../Utility/MathHelper';
import { StartAudio } from '../../Audio/AudioHelper';
import Scene from '../../../Scene/Scene';
import { AUDIO_UI_PRIZE_WHEEL_SPIN } from '../../Audio';
import { AudioTrackType } from '../../Audio/AudioClip';

const SLICES: number = 8;

export class WheelSpin extends AnimationClip {
    private pin: ElementComponent;
    private bright: ElementComponent;
    private bulbs: Renderable[];
    private scene: Scene;
    private curr: any;

    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        this.scene = meta.scene;

        this.pin = meta.pin.getComponent(ElementComponent);
        this.pin.rotation = this.pin.rotation % (Math.PI * 2);

        this.bright = meta.bright.getComponent(ElementComponent);
        this.bright.rotation = this.bright.rotation % (Math.PI * 2);

        // Make sure the brightness-sprite is visible.
        meta.bright.getComponent(Renderable).visible = true;
        meta.bright.getComponent(Renderable).alpha = 1;

        this.bulbs = [];
        meta.bulbs.forEach((bulb: GameObject) => {
            const renderable = bulb.getComponent(Renderable);
            renderable.alpha = 1;
            this.bulbs.push(renderable);
        });

        // Random value closer to the slide border to create some "expectation".
        const rnd = Random.int(10, 18) * Random.sign();

        // Get start and end angles.
        const startAngle = this.pin.rotation;
        const endAngle = ((meta.angle + 360 * 8 + rnd) / 180) * Math.PI;

        // First step: two laps (720) with a BackIn easing (Anticipation).
        const tweenRotation1 = this.getTween(this.pin);
        tweenRotation1
            .to(
                {
                    rotation: startAngle + Math.PI * 4,
                },
                1000
            )
            .easing(Easing.Back.In);

        yield* this.startTween(tweenRotation1);

        // Seconds step: complete rotations, slowing down.
        const tweenRotation2 = this.getTween(this.pin);
        tweenRotation2
            .to(
                {
                    rotation: endAngle,
                },
                7000
            )
            .easing(Easing.Quintic.Out);

        yield* this.startTween(tweenRotation2);
    }

    public update(): void {
        super.update();

        // Rotate bright.
        const slice = Math.floor(
            (this.pin.rotation - Math.PI / 8) / (Math.PI / 4)
        );
        this.bright.rotation = slice * (Math.PI / 4);

        // Highlight the bulbs from the current slice.
        const curr = MathHelper.repeat(slice, SLICES);
        const next = MathHelper.repeat(slice + 1, SLICES);

        if (this.curr !== curr) {
            StartAudio(
                this.scene,
                AUDIO_UI_PRIZE_WHEEL_SPIN,
                AudioTrackType.SFX
            );
            this.curr = curr;
        }

        this.bulbs.forEach((bulb, index) => {
            if (index === curr || index === next) {
                bulb.alpha = 1;
            } else {
                bulb.alpha = Math.max(0, bulb.alpha - 0.05);
            }
        });
    }
}
